import { useEffect, useState } from "react";
import {useLocation} from "react-router-dom";
import axios from "axios";

function ExampleCrafMyPDF() {

    const [isLoaded, setIsLoaded] = useState(false);
    const [pdfData, setPdfData] = useState(null);
    const [pimData, setPimData] = useState(null);
    const [isAdmin, setIsAdmin] = useState(0);
    const [pdfUrl, setPdfUrl] = useState(null);
    
    const [currentIds, setCurrentIds] = useState(null);
    const [currentLocale, setCurrentLocale] = useState(null);
    const [idTemplate, setIdTemplate] = useState(null);

    const search = useLocation().search;
    const API_BASE_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:4000"
        : "";
    
    function fetchPdf() {
        fetch(`${API_BASE_URL}/api/getPdf`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                currentIds,
                currentLocale,
                idTemplate
            })
        })
            .then(response => {
                if (!response.ok) throw new Error("Failed to fetch PDF");
                return response.json();
            })
            .then(data => {
                console.log("PDF URL:", data.pdfUrl);
                window.open(data.pdfUrl, "_blank"); // ✅ Open PDF in a new tab
            })
            .catch(error => {
                console.error("Error fetching PDF:", error);
            });
    }

    useEffect(() => {
        //1 - We get the [ids, token, isAdmin, locale, template] from the URL TODO : for what ?
        const currentIds = new URLSearchParams(search).get('ids');
        const currentToken = new URLSearchParams(search).get('token');
        setIsAdmin(new URLSearchParams(search).get('isAdmin'));
        const currenLocale = new URLSearchParams(search).get('locale');
        const idTemplate = new URLSearchParams(search).get('template');

        setCurrentIds(new URLSearchParams(search).get("ids"));
        setIsAdmin(new URLSearchParams(search).get("isAdmin"));
        setCurrentLocale(new URLSearchParams(search).get("locale"));
        setIdTemplate(new URLSearchParams(search).get("template"));

        //2 - We name the page
        document.title = "Templates Tageos";

        //3 - We Setup the different URL for the API (GET and Generate PDF) #TODO: we should use a config file
        let dataUrl = `${API_BASE_URL}/api/getDataPDFB2C}`;
        let pdfGenerateUrl = `${API_BASE_URL}/api/generatePDF`;
        let dataGraphQl = `${API_BASE_URL}/api/getPimPdf`;

        //We are going to fetch the data of our product encapsulating the call on our backend
        //We are going to use the GraphQL API to get the data of our product
        //


        //4 - We get the data from our backend // api/getDataPDFB2C
        // We use the axios library to make the request
        // We use the GET method to get the data from our backend
        axios.get(dataUrl,{params: {token: encodeURIComponent(currentToken), ids:currentIds, locale: currenLocale,template:idTemplate}}).then(resp => {
            if (resp.status === 200) {	
                const isSomeDataIncomplete = resp.data.dataIncomplete;
                setPimData(resp.data.payloadCraftList[0].data);
                //5 - We generate the PDF if we have the data from our backend // api/generatePDF
                axios.post(pdfGenerateUrl,resp.data,{params: {token: encodeURIComponent(currentToken), ids:currentIds, locale: currenLocale,template:idTemplate}}).then((respCraft) =>{
                    if (respCraft.status === 200) {
                        let result = respCraft.data;
                        result["dataIncomplete"] = isSomeDataIncomplete;
                        setPdfData(result);
                    } else {
                        console.log("error",resp.data);
                    }
                    setIsLoaded(true);
                }).catch(error => {
                    console.log(error);
                    setIsLoaded(true);
                });
            } else {
                setIsLoaded(true);
                console.log("error",resp.data);
            }
        }).catch(error => {
            console.log(error);
            setIsLoaded(true);
        });
    }, []);

    let dataPdf;
    let refJsonContent;
    if (pimData) {
        refJsonContent = `data:text/json;chatset=utf-8,${encodeURIComponent(JSON.stringify(pimData,null,4))}`;
    }

    //6 - Once we load the data we display it
    if (isLoaded) {
        if (pdfData != null) {
            let listStructData =  [];

      		const dataLength =pdfData.pdfList.length;
            for (let index = 0; index < dataLength; index++) {
                const element = pdfData.pdfList[index];
                if (index === dataLength -1) {
                    console.log("last");
                }
                const urlWithoutQueryParams =element.file.split("?")[0];
                const urlPathElements = urlWithoutQueryParams.split("/");
                const filename =  urlPathElements[urlPathElements.length -1];
                listStructData.push({file:element.file,filename:filename} );
            }
            dataPdf = <div style={styleExemplePage.pdfLinkContainer} >{listStructData.map((link) => <a href={link.file} target="_blank" rel="noreferrer">{link.filename}</a>)}</div>;
        } else {
            dataPdf = <div className='pdfLoader'> Erreur dans la récupération des données ou dans la generation des PDF</div>;
        }
    } else {
        dataPdf =<div className='pdfLoader'>Récupération des données...<br/>Veuillez Patienter</div>;
    }

    //7- We return the JSX
    return (
        <div style={{margin: 0}}>
            <div style={styleExemplePage.pdfLinkContainer}>
      			<h2>Mes PDF</h2>
    		</div>
            <button onClick={() => fetchPdf(currentIds, currentLocale, idTemplate)}>
                Generate PDF
            </button>
            { pimData != null && isAdmin === "1" &&
			<div style={styleExemplePage.pdfLinkContainer}>
			    <a  href={refJsonContent} download={"dataPim.json"} >
						Contenu de l&apos;onglet DATA de Craft My PDF
			    </a>
			</div>
            }
            <div style={styleExemplePage.pdfLinkContainer}>
                {dataPdf}
            </div>
            {isLoaded && pdfData != null && pdfData.dataIncomplete === true &&
				<div style={styleExemplePage.pdfLinkContainer}>
				    <p style={styleExemplePage.textError} ><i>Certains des séjours semblent incompatibles ou incomplets pour le format de fiche attendue. Etes-vous sûr d&apos;avoir par exemple un village et des expériences associées ?</i></p>
				</div>
            }
        </div>
    );
}

const styleExemplePage = {
    pdfLinkContainer : {
        display: "flex",
        flexDirection: "column",
        textAlign:"center",
        alignItems: "center"
    },
    centerContainer: {
        display: "flex",
        justifyContent: "center"
    },
    textError:{
        "text-align":"center",
        "padding":20
    },
    dataPimBtnContainer: {
        color:"white",
        backgroundColor:"blue",
        width:300,
        paddingBottom: 15,
        paddingTop: 15,
        paddingRight:25,
        paddingLeft:25,
        margin:5,
        textDecoration:"none",
        borderRadius:5
		
    }
};


export default ExampleCrafMyPDF;